// @flow
import React from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';

const propTypes = {
  children: PropTypes.any,
  type: PropTypes.oneOf(['text', 'email', 'number', 'tel', 'password']),
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired
};
const defaultProps = {
  type: 'text',
  autoComplete: 'off',
  autoCorrect: 'off',
  spellCheck: 'false'
};

const StyledInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border-width: 1px;
  border-radius: 2px;
  border-style: solid;
  border-color: ${props => props.theme.TextInput_border_color};
  margin-bottom: 1rem;
  box-shadow: 0 1px 5px 0 rgba(155,155,155,0.37);
  &.touched.error {
    border-color: #c12828;
  }
`;

const StyledInput = styled.input`
  background: ${props => props.theme.TextInput_background_color};
  color: ${props => props.theme.TextInput_color};
  flex: 1 0;
  font-family: inherit !important;
  line-height: 1em;
  padding: 0.875rem;
  margin: 0;
  height: 1rem;
  border-radius: 0;
  box-sizing: content-box;
  overflow-x: hidden;
  text-overflow: ellipsis;
  
  &::-webkit-input-placeholder {
    color: ${props => props.theme.TextInput_placeholder_color};
    height: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
    overflow: visible;
    margin: 0;
  }
  
  &:required, &:invalid {
    box-shadow: none;
  }
`;

const TextInput = (props:Object) => {
  const { children, tabIndex, className, onMouseDown, onTouchStart, ...inputProps } = props;
  return (
    <StyledInputWrapper
      className={className}
      tabIndex={tabIndex}
      disabled={inputProps.disabled}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
    >
      <StyledInput {...inputProps} />
      {children}
    </StyledInputWrapper>
  );
};

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export default TextInput;



// WEBPACK FOOTER //
// ./src/modules/common/components/textinput/TextInput.js